import React, { PropsWithChildren } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import BadgeCount from "modules/providers/badge-count";
import { CookiesProvider } from "react-cookie";
import { AuthProvider } from "./auth-provider";
import { DistributionGroupsProvider } from "./distribution-groups-provider";
import { FileProvider } from "./file-provider";
import { GlobalEditingStateProvider } from "./global-editing-state-provider/global-editing-state-provider";
import { GlobalStateProvider } from "./global-state-provider";
import { MessageHoverProvider } from "./message-hover-provider";
import { MessageThreadNavigationProvider } from "./message-thread-navigation-provider";
import { MixpanelProvider } from "./mixpanel-provider/mixpanel-provider";
import { NotificationProvider } from "./notification-provider";
import { OrganizationProvider } from "./organization-provider";
import { OverlayProvider } from "./overlay-provider";
import Drawers from "./overlay-provider/drawers";
import Modals from "./overlay-provider/modals";
import { PanelSizeProvider } from "./panel-size-provider";
import { PrintProvider } from "./print-provider";
import { PubSubProvider } from "./pub-sub-provider";
import { TagsProvider } from "./tags-provider";
import { TypingProvider } from "./typing-provider";
import { UserAttributesProvider } from "./user-attributes-provider";
import { UsersProvider } from "./users-provider";
import { UserPresenceProvider } from "./user-presence-provider";
import { VideoCallProvider } from "./video-call-provider";
import { WebSocketProvider } from "./websocket-provider";

interface IProps extends PropsWithChildren {}

const Providers: React.FC<IProps> = ({ children }) => (
  <CookiesProvider>
    <PubSubProvider>
      <AuthProvider>
        <BadgeCount />
        <PrintProvider>
          <FileProvider>
            <UserAttributesProvider>
              <UsersProvider>
                <UserPresenceProvider>
                  <TagsProvider>
                    <DistributionGroupsProvider>
                      <OrganizationProvider>
                        <MixpanelProvider>
                          <NotificationProvider>
                            <TypingProvider>
                              <GlobalStateProvider>
                                <GlobalEditingStateProvider>
                                  <MessageHoverProvider>
                                    <MessageThreadNavigationProvider>
                                      <PanelSizeProvider>
                                        <OverlayProvider>
                                          <VideoCallProvider>
                                            <WebSocketProvider>
                                              <DndProvider backend={HTML5Backend}>
                                                {children}
                                                <Drawers />
                                                <Modals />
                                              </DndProvider>
                                            </WebSocketProvider>
                                          </VideoCallProvider>
                                        </OverlayProvider>
                                      </PanelSizeProvider>
                                    </MessageThreadNavigationProvider>
                                  </MessageHoverProvider>
                                </GlobalEditingStateProvider>
                              </GlobalStateProvider>
                            </TypingProvider>
                          </NotificationProvider>
                        </MixpanelProvider>
                      </OrganizationProvider>
                    </DistributionGroupsProvider>
                  </TagsProvider>
                </UserPresenceProvider>
              </UsersProvider>
            </UserAttributesProvider>
          </FileProvider>
        </PrintProvider>
      </AuthProvider>
    </PubSubProvider>
  </CookiesProvider>
);

export default Providers;
